import { IonFooter } from '@ionic/react'
import { trash, checkmarkCircleOutline } from 'ionicons/icons'
import { useEffect, useRef, useState } from 'react'
import ReactPainter from 'react-painter'
import { IconButton } from '~/shared/ui/Buttons'
import { myPalette } from '~/shared/ui/theme'
import { IonToolbar, ToolbarWrapper } from '../styled'
import { CanvasWrapper, Wrapper } from './styled'

type PainterModalProps = {
  imageFile: File
  onOk: (blob: File) => void
  onDelete: () => void
  canPaint?: boolean
}

export function Painter({
  imageFile,
  onDelete,
  onOk,
  canPaint,
}: PainterModalProps) {
  const [widthEnvironment, setWidthEnvironment] = useState<number>()
  const canvasRef = useRef<ReactPainter>(null)

  const handleOk = async () => {
    const canvas = canvasRef?.current?.canvasRef
    const dataUrl = canvas?.toDataURL('image/jpeg', 1)
    const blob = await fetch(dataUrl as string).then((res) => res.blob())
    const file = new File([blob as Blob], 'Photo', {
      type: 'image/jpeg',
    })
    onOk(file)
  }

  useEffect(() => {
    const element = document.getElementById('painter-block')
    setWidthEnvironment(element?.offsetWidth || 300)
  }, [imageFile])

  if (!imageFile) return null

  return (
    <>
      <Wrapper id='painter-block'>
        {widthEnvironment && (
          <ReactPainter
            ref={canvasRef}
            initialColor={myPalette.red.main}
            image={imageFile}
            width={widthEnvironment}
            render={({ canvas }) => (
              <CanvasWrapper
                style={{
                  ...(canPaint ? {} : { pointerEvents: 'none' }),
                }}
              >
                {canvas}
              </CanvasWrapper>
            )}
          />
        )}
      </Wrapper>
      <IonFooter>
        <IonToolbar>
          <ToolbarWrapper>
            <IconButton
              onClick={onDelete}
              icon={trash}
              style={{ fontSize: '16px', padding: '6px' }}
              iconProps={{ style: { color: myPalette.red.main } }}
              size='large'
              variant='fillWhite'
              data-testid='delete-painter'
            />

            <IconButton
              onClick={handleOk}
              icon={checkmarkCircleOutline}
              style={{ fontSize: '16px', padding: '6px' }}
              iconProps={{
                style: { color: myPalette.green.main },
              }}
              size='large'
              data-testid='save-painter'
              variant='fillWhite'
            />
          </ToolbarWrapper>
        </IonToolbar>
      </IonFooter>
    </>
  )
}
